
import React, { useState, useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useHistory, useLocation } from 'react-router-dom';
import Accountants from './Accountants';
import BusinessOwners from './BusinessOwners';
import FinancialInstitution from './FinancialInstitution';
import './UseCase.css';

import WavesTop from '../../../assets/journaler/solutions/waves_top.png'
import styles from './index.module.css'

const CASE_TAB = {
    accountants: 'accountants',
    business: 'business',
    financial: 'financial'
}

const DEFAULT_CASE = CASE_TAB.accountants;

const UseCase = () => {
    const history = useHistory();
    const location = useLocation();

    const getCaseFromUrl = () => {
        const params = new URLSearchParams(location.search);
        const caseParam = params.get('case');
        return Object.values(CASE_TAB).includes(caseParam) ? caseParam : DEFAULT_CASE;
    }

    // Lazy initialization - only runs once on mount
    const [mobileWallet, setMobileWallet] = useState(() => getCaseFromUrl());

    // Sync state with URL changes (browser back/forward only)
    useEffect(() => {
        const caseFromUrl = getCaseFromUrl();
        // Only update if value changed to avoid unnecessary re-renders
        setMobileWallet(prevCase => {
            return caseFromUrl !== prevCase ? caseFromUrl : prevCase;
        });
    }, [location.search]);

    const onChangeMobile = (caseValue) => {
        setMobileWallet(caseValue);
        history.replace(`/journaler/usecase?case=${caseValue}`);
    }

    const isMobile = useMediaQuery({ maxWidth: 700 });

    const bodyUseCase = () => {
        if (mobileWallet === CASE_TAB.accountants) {
            return (<Accountants />)
        }
        else if (mobileWallet === CASE_TAB.business) {
            return <BusinessOwners />
        }
        else {
            return <FinancialInstitution />
        }

    }

    return (
        <div className='position-relative w-100' style={{ overflow: 'hidden' }}>
            <div className='container text-center pt-5' style={{ marginTop: 70 }}>
                <span className='usecase-header'>Use Cases</span>

            </div>

            <img className={styles.wavesTop} src={WavesTop} alt='waves top' />

            {!isMobile ? <div className='container'>

                <div className="d-flex justify-content-center pt-5">
                    <div className='pr-5'>
                        <button onClick={() => onChangeMobile(CASE_TAB.accountants)} className={mobileWallet === CASE_TAB.accountants ? 'clickbBtnSimplifyUsecase' : 'btnSimplifyUsecase'}>Accountants</button>
                    </div>
                    <div className='pr-5'>
                        <button onClick={() => onChangeMobile(CASE_TAB.business)} className={mobileWallet === CASE_TAB.business ? 'clickbBtnSimplifyUsecase' : 'btnSimplifyUsecase'}>Business Owners</button>
                    </div>
                    <div>
                        <button onClick={() => onChangeMobile(CASE_TAB.financial)} className={mobileWallet === CASE_TAB.financial ? 'clickbBtnSimplifyUsecase' : 'btnSimplifyUsecase'}>Financial Institutions</button>
                    </div>
                </div>
            </div> :

                <div >
                    <div className='d-flex justify-content-center pt-3'>
                        <button onClick={() => onChangeMobile(CASE_TAB.accountants)} className={mobileWallet === CASE_TAB.accountants ? 'clickbBtnSimplifyUsecase' : 'btnSimplifyUsecase'}>Accountants</button>
                    </div>
                    <div className='d-flex justify-content-center pt-3'>
                        <button onClick={() => onChangeMobile(CASE_TAB.business)} className={mobileWallet === CASE_TAB.business ? 'clickbBtnSimplifyUsecase' : 'btnSimplifyUsecase'}>Business Owners</button>
                    </div>
                    <div className='d-flex justify-content-center pt-3'>
                        <button onClick={() => onChangeMobile(CASE_TAB.financial)} className={mobileWallet === CASE_TAB.financial ? 'clickbBtnSimplifyUsecase' : 'btnSimplifyUsecase'}>Financial Institutions</button>
                    </div>
                </div>

            }

            {bodyUseCase()}
        </div>
    )
}


export default UseCase;